import React from "react";
import { PlanInputSelectDTO } from "../../../models/plan/plan.response";

interface PaymentSlipViewProps {
    plan? : PlanInputSelectDTO;
    onClose: () => void;
}

const PaymentSlipView: React.FC<PaymentSlipViewProps> = ({ onClose, plan }) => {

    return (
        <section className="payment-slip-section" onClick={onClose}>
            <div className="w-layout-blockcontainer container w-container">
                <div className="payment-slip-wrapper">
                    <div className="payment-slip-div" onClick={(e) => e.stopPropagation()}>
                        <div id="w-node-_861a7727-db6a-b702-e98a-67d1d3ffaf69-1cee91cf" className="text-block-27">NALOG ZA UPLATU</div>
                        <div className="payment-slip-column left-div">
                            <div className="payment-slip-row-div">
                                <div className="payment-slip-row-text">Uplatilac</div>
                                <div className="payment-slip-input-div">
                                    <div className="payment-slip-input-text">&quot;Vaše ime i prezime &quot;</div>
                                    <div className="payment-slip-input-text exaple">Marko Markovic (PRIMER)</div>
                                </div>
                            </div>
                            <div className="payment-slip-row-div">
                                <div className="payment-slip-row-text">Svrha uplate</div>
                                <div className="payment-slip-input-div">
                                    <div className="payment-slip-input-text">DM - &quot;ime lokala&quot; - &quot;mesec/godina &quot; {plan?.name || "*Naziv plana*"}</div>
                                    <div className="payment-slip-input-text exaple">DM - Kafana Tri Šešira - 01/2025 (PRIMER)</div>
                                </div>
                            </div>
                            <div className="payment-slip-row-div">
                                <div className="payment-slip-row-text">Primalac</div>
                                <div className="payment-slip-input-div">
                                    <div className="payment-slip-input-text">Srđan Delić</div>
                                </div>
                            </div>
                        </div>
                        <div className="payment-slip-column">
                            <div className="div-block-22">
                                <div className="payment-slip-small-row-div">
                                    <div>Šifra plćanja</div>
                                    <div className="payment-slip-small-row-box-div">
                                        <div className="payment-slip-input-text">289</div>
                                    </div>
                                </div>
                                <div className="payment-slip-small-row-div">
                                    <div>Valuta</div>
                                    <div className="payment-slip-small-row-box-div"></div>
                                </div>
                                <div id="w-node-_3635721c-210d-bd44-4ebd-60f2c0418bb1-1cee91cf" className="payment-slip-small-row-div">
                                    <div>Iznos</div>
                                    <div className="payment-slip-small-row-box-div">
                                        <div className="payment-slip-input-text">{plan?.price.toFixed(2) || "3.000,00"}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="div-block-22">
                                <div className="payment-slip-small-row-div"></div>
                                <div id="w-node-da1c801c-3988-367f-7b01-e6af44545475-1cee91cf" className="payment-slip-small-row-div">
                                    <div>Racun primaoca</div>
                                    <div className="payment-slip-small-row-box-div">
                                        <div className="payment-slip-input-text">170-10687417000-04</div>
                                    </div>
                                </div>
                            </div>
                            <div className="div-block-22">
                                <div className="payment-slip-small-row-div">
                                    <div>Broj modela</div>
                                    <div className="payment-slip-small-row-box-div">
                                        <div className="payment-slip-input-text">97</div>
                                    </div>
                                </div>
                                <div id="w-node-_8f61d116-1751-bbde-1f5f-1c3bc0d95b3a-1cee91cf" className="payment-slip-small-row-div">
                                    <div>Poziv na broj (odobrenje)</div>
                                    <div className="payment-slip-small-row-box-div"></div>
                                </div>
                            </div>
                        </div>
                        <div id="w-node-_228d7cf3-ef7f-524e-cc0c-34dd11d6761d-1cee91cf" className="div-block-24">
                            <div className="div-block-23">
                                <div className="payment-slip-bottom-inputs">Pečat ipotpis uplatioca</div>
                            </div>
                            <div className="div-block-23">
                                <div className="payment-slip-bottom-inputs">Mesto i datum prijema</div>
                            </div>
                            <div className="div-block-23">
                                <div className="payment-slip-bottom-inputs">Datum valute</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
};

export default PaymentSlipView;